module.exports = __webpack_public_path__ + "media/images/common/category_star-f32caae077df595dc263b534b432bd30.png";